import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../../services';
import $ from 'jquery'
import DropDownCellCorrelativa from '../myDropDownCellCorrelativa';
import { auto } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';
import DropDownCellCorrelativaProduto from '../myDropDownCellCorrelativaProduto';
// export const DropDownCellProduto = props => {

  var optionsProdutos = [];
  var optionsProdutosFilter = [];
  var DropDownCellTipoVasilha = null;
  var filterArray = [];
  var ProdutoToSearch = null;
  var IdCorrelativas = null;
myFunction()
function myFunction() {
  var ProdutoString = {};

  var optionsProdutos = [];

  (async () => {
    if($('#instal_vinica_auto').val() != '' & $('#instal_vinica_auto').val() != null){
      const data = {"IDInstalacaoVinica":$('#instal_vinica_auto').val().split('!')[0]}
      const ProdutoList = await services.apiCall.requestApi(
          "/Fiscalizacao/GetProdutos",
          data,
          "get"
      );

      if(ProdutoList){
        ProdutoList.map((Produto) => (
          ProdutoString = {text: "" + Produto.produto + " - " + Produto.tipoConta + " - " + (Produto.numeroRegisto != null ? Produto.numeroRegisto : 0) + " - " + Produto.cor + " - " + Produto.anoProduto + " - " + Produto.estado + " - " + Produto.saldo,
          value: Produto.idContaCorrente + "-" + Produto.idRegistoProduto},

          ProdutoString.text += Produto.mencoes != "" || Produto.mencaoObrigatoria != "" ? (Produto.mencoes != "" ? " - " + Produto.mencoes : " - Sem menção") + (Produto.mencaoObrigatoria != "" ? " - " + Produto.mencaoObrigatoria : " - Sem menção qualitativa") : " - Sem menções",

          optionsProdutosFilter.push(ProdutoString)
        ));

        // optionsProdutosFilter = optionsProdutos;

      }

    }
})();};

class DropDownCellProduto2 extends Component {

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });
    IdCorrelativas = e;
    DropDownCellCorrelativaProduto.ChangeValueById(IdCorrelativas);
   
  }

  componentDidMount = () => {

    myFunction();

  }



  filterData = (filter) => {

    var FilterOptions = [];

    var indexCheck = [];

    filterArray = [];

    filterArray = filter.value.split(" ")

    $.map( optionsProdutos, function( val, i ) {

      ProdutoToSearch = val;

      indexCheck = [];

      $.map( filterArray, function( val, i ) {

        if(ProdutoToSearch.text.toUpperCase().indexOf(val.toUpperCase()) > -1){
          indexCheck.push("true");
        }else{
          indexCheck.push("false")
        }

      })
  
      if(indexCheck.indexOf("false") == -1){
        FilterOptions.push(ProdutoToSearch);
      }

    })

    // optionsProdutos.map((Produto) => (

    //   filterArray.map((filterSplit) => (

    //     Produto.text.toUpperCase().indexOf(filterSplit.toUpperCase()) > -1 ? indexCheck.push("true") : indexCheck.push("false")

    //   )),

    //   indexCheck.filter("false").length > 0 ? null : FilterOptions.push(Produto)

    //   // Produto.text.toUpperCase().indexOf(filter.value.toUpperCase()) > -1 ? FilterOptions.push(Produto) : undefined

    // ));


    optionsProdutosFilter = FilterOptions;

  };


  filterChange = (event) => {

    this.filterData(event.filter);

    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field
    });

  };

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    optionsProdutosFilter = optionsProdutosFilter.length < optionsProdutos.length ? optionsProdutosFilter : optionsProdutos;

    return (
      
        <td>
        
            {dataItem.inEdit ?
            <DropDownList
                filterable={true}
                onFilterChange={this.filterChange}
                popupSettings={{
                  width: 'max-content',
                }}
                onChange={this.handleChange}
                value={optionsProdutos.length > 0 ? optionsProdutos.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null)) : dataItem.Produto_NC_GA_IG_engarrafado}
                data={optionsProdutosFilter}
                textField="text"
                id= {field == 'Produto_NC_GA_IG_engarrafado' ? 'id-DropDownCellProdutosEngarrafado' : 'id-DropDownCellProdutos'}
            />
            : dataValue != null ? dataValue.text.toString() : undefined}
        </td>
    );
  }
}

export default DropDownCellProduto2;